import { responsiveAvatarSize } from "@portal/configs/theme/themeConfig";

import { capitalize } from "lodash";
import { Avatar } from "../Avatar/AntAvatar";
import { DateText } from "../Date/DateText";
import { Flex } from "../Flex/Flex";
import { HideWrapper } from "../HideWrapper/HideWrapper";
import { ImageComponent } from "../Image/AntImage";
import { TypographyText } from "../Typography/AntTypography";
import { ProfileProps } from "./type";

function Profile(props: ProfileProps) {
  const {
    firstName,
    lastName,
    textStyle,
    hideAvatar,
    designation,
    imageUrl,
    dateAndTime,
    hideInfo,
    avatarStyle,
    wrapperStyle,
  } = props;

  function getAvatarSize() {
    return avatarStyle?.size === "responsive"
      ? responsiveAvatarSize
      : avatarStyle?.size;
  }

  const size = getAvatarSize();

  const ProfileImage = (
    <ImageComponent
      src={imageUrl}
      preview={false}
      width="100%"
      height="100%"
      style={{ objectFit: "cover" }}
    />
  );

  const AvatarComponent = imageUrl ? (
    <Avatar.Image
      src={ProfileImage}
      size={size}
      style={{ ...avatarStyle?.style }}
    />
  ) : (
    <Avatar.Names
      name={[firstName ?? "", lastName ?? ""]}
      namesProps={{ avatarProps: { size }, style: { ...avatarStyle?.style } }}
    />
  );

  const ProfileName = (
    <TypographyText {...textStyle?.name}>{`${capitalize(
      firstName
    )} ${capitalize(lastName ?? "")}`}</TypographyText>
  );
  const Date = dateAndTime ? (
    <DateText value={dateAndTime} textProps={textStyle?.date} showTime  />
  ) : null;

  const Designation = (
    <HideWrapper hide={!designation}>
      <TypographyText
        fs="12"
        style={{ color: "var(--gray-7)" }}
        {...textStyle?.designation}
      >{`${designation ?? ""}`}</TypographyText>
    </HideWrapper>
  );

  const AvatarArea = (
    <HideWrapper hide={Boolean(hideAvatar)}>{AvatarComponent}</HideWrapper>
  );

  const ProfileInfo = (
    <Flex justify="start" space="2" vertical>
      {ProfileName}
      {Designation}
    </Flex>
  );

  const Timestamp = <>{Date}</>;

  const InfoAreaLayout = (
    <HideWrapper hide={Boolean(hideInfo)}>
      <Flex vertical space="2">
        {ProfileInfo}
        {Timestamp}
      </Flex>
    </HideWrapper>
  );

  return (
    <Flex
      justify="start"
      align="start"
      space="12"
      {...wrapperStyle}
      style={{ width: "100%" }}
    >
      {AvatarArea}
      {InfoAreaLayout}
    </Flex>
  );
}

export { Profile };
